import { FormInstance } from 'antd';
import { isRealHts } from '@xbcb/entry-utils/dist/lib/htsUtil';
import { NamePath } from '@xbcb/ui-types';

export const getRealTariffIndex = (
  form: FormInstance,
  linesNamePath: NamePath,
): number | undefined => {
  const lines = form.getFieldValue(linesNamePath) || [];
  let tariffIndex;
  if (lines.length === 1) {
    const { tariffs } = lines[0];
    if (tariffs) {
      tariffIndex =
        tariffs.length === 1
          ? 0
          : tariffs.length === 2 && isRealHts(tariffs?.[1]?.htsNumber)
          ? 1
          : tariffs.length === 3 && isRealHts(tariffs?.[2]?.htsNumber)
          ? 2
          : undefined;
    }
  }
  return tariffIndex;
};
